import { Component } from "react";
import * as Scrivito from "scrivito";

class OutroPageWidget extends Component {
  render() {
    const { widget } = this.props;
    return (
      <div className="container form-intro">
        <div className="form-intro-headline">
          <Scrivito.ContentTag
            tag="h2"
            content={widget}
            attribute="headline"
            className="headline-form"
          />
        </div>
        <div className="form-intro-hint">
          <Scrivito.ContentTag
            tag="h6"
            content={widget}
            attribute="hint"
            className="hint-form"
          />
        </div>
      </div>
    );
  }
}

Scrivito.provideComponent("OutroPageWidget", OutroPageWidget);
